import {
  Box, DashboardModule, Form, Text,
} from '@domain-group/suit-theme'

import { useUserForm } from '@hooks/useUser'

import countryCallingCodes from '@functions/countryCallingCodes'

interface AccountProps {
  userFormPayload: ReturnType<typeof useUserForm>,
}

const Account = (props: AccountProps) => {
  const { userFormPayload } = props

  const {
    entityState: {
      country_calling_code,
      mobile_number,
      username,
      password,
      password_confirmation,
    },
    errors,
    handlers,
  } = userFormPayload

  return (
    <DashboardModule title="Account" boxProps={{ marginBottom: 'large' }}>
      <Form padding="large">
        <Text color="faintGrey" fontSize="xsmall" lineHeight={1.3}>
          Your username will log you in to the system. We recommend your email but it must be unique and not already
          in use.
        </Text>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.username} label="* Username">
            <input name="username" type="username" value={username} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field boxProps={{ flex: 1 }} label="Mobile" marginTop={['large', 0]}>
            <Box style={{ flexDirection: 'row', marginRight: 'small', width: '100%' }}>
              {/*
               // @ts-expect-error TS2322 */}
              <select name="country_calling_code" value={country_calling_code} {...handlers}>
                {countryCallingCodes.map(({ key, value, title }) => (
                  <option key={key} value={value}>
                    {title}
                  </option>
                ))}
              </select>

              <Form.Field boxProps={{ marginLeft: 'small', width: '70%' }}>
                <input type="text" value={mobile_number} name="mobile_number" {...handlers} />
              </Form.Field>
            </Box>
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="* Set Password">
            <input autoComplete="off" type="password" name="password" value={password} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="* Confirm Password" marginTop={['large', 0]}>
            <input
              autoComplete="off"
              type="password"
              name="password_confirmation"
              value={password_confirmation}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default Account
